import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/images/logo/gt-text-beautyagent.svg';
var _hoisted_1 = {
  class: "img-fallback"
};

var _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock("div", _hoisted_1, [_hoisted_2]);
}